import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { OfferCtaTypesEnum } from '../pricing-data.data';

export const PRICING_OFFER_CTA_SCHEMA = Object.freeze({
  TYPE: OfferCtaTypesEnum,
  TITLE: '',
  URI: '',
});

const RECORD = generateSchema(PRICING_OFFER_CTA_SCHEMA);
const KEYS: any = generateKeys(PRICING_OFFER_CTA_SCHEMA);

export class PricingOfferCta extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): OfferCtaTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get uri(): string {
    return this.get(KEYS.URI);
  }
}
